// Module
var code = "<tour-step-body><span translate=\"library-filter-and-sort-tour_body\"></span></tour-step-body>";
// Exports
module.exports = code;